import { useTheme } from '@material-ui/core';
import Organization from 'classes/Organization';
import { NotificationsSnackBar } from 'components/Shared/DynamicForm';
import withAppStylesGrid from 'HOCs/withAppStyles';
import withEditFunctions from 'HOCs/withEditFunctions';
import { useAppContext } from 'hooks/useAppContext';
import { useAuthContext } from 'hooks/useAuthContext';
import MaterialTable from 'material-table';
import React, { useState } from 'react';
import {deleteOrganization, getOrganizations } from 'utils/OrganizationUtils';

const OrganizationsGrid = () => {
    const [editStatus, setEditStatus] = useState({ success: undefined, alertType: undefined, message: "" });
    const theme = useTheme();
    const { role } = useAuthContext();
    const { selectedProject } = useAppContext();
    const title = "Organizations";

    const formPath = () => import('components/AdminConfig/Organizations/OrganizationForm');

    const StyledMaterialTable = 
        withEditFunctions(
            withAppStylesGrid(MaterialTable, 
                { theme, getRecords: getOrganizations }),
            { formPath, role, deleteRecord: deleteOrganization, canDelete: true, canUpdate: true, selectedProject, component: "AdminConfig" }
        );

    return (
        <>
        <StyledMaterialTable
            columns={Organization.columns}
            options={{
                // paging: false
                pageSize: 10,
                pageSizeOptions: [10, 20, 25]
            }}
            title={title}
            localization={{
                body: { editRow: { deleteText: "Are you sure you'd like to mark this row as inactive?" } }
            }}
        />
        <NotificationsSnackBar status={editStatus} setStatus={(status) => setEditStatus(old => ({ ...old, success: status }))} refreshLagTime={3000} />
        </>
        
    )

}

export default OrganizationsGrid;